// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAuthUser } from '../context/AuthUserContext';

export default function ProtectedRoute({ children, tipo = 'admin' }) {
  const { isAuth }                    = useAuth();
  const { estaLogueado, loading }     = useAuthUser();

  // Ruta de admin (/admin/*)
  if (tipo === 'admin') {
    if (!isAuth) return <Navigate to="/admin/login" replace />;
    return children;
  }

  // Ruta de usuario (/mi-cuenta)
  if (loading) return (
    <div style={{
      display:'flex', alignItems:'center', justifyContent:'center',
      height:'100vh', fontFamily:'DM Sans, sans-serif',
      color:'#5a6a63', gap:'.8rem'
    }}>
      <svg viewBox="0 0 24 24" fill="none" width="24" height="24"
        style={{animation:'spin .7s linear infinite'}}>
        <circle cx="12" cy="12" r="10" stroke="#d4f4e8" strokeWidth="2"/>
        <path d="M12 2a10 10 0 0110 10" stroke="#4db88a" strokeWidth="2" strokeLinecap="round"/>
      </svg>
      Cargando…
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  if (!estaLogueado) return <Navigate to="/login" state={{ from: '/mi-cuenta' }} replace />;
  return children;
}